import taskService from 'resources/task/task.service';
import commentService from 'resources/comment/comment.service';

export const getMilestoneCommentsToResolve = async (milestoneId) => {
  const tasks = await taskService.getMilestoneTasks(milestoneId);

  const milestoneAuditComments = [];
  const taskIds = tasks.map((task) => task.id);
  const tasksAuditComments = await commentService.getTasksAuditCommentsToResolve(taskIds);

  tasks.forEach((task) => {
    const taskAuditComments = tasksAuditComments?.filter((comment) => comment.task_id === task.id);

    if (taskAuditComments?.length) {
      milestoneAuditComments.push(taskAuditComments);
    }
  });

  return milestoneAuditComments;
};
